export default __webpack_public_path__ + "static/avatar-tag-2-do-light-cf03c958d209b2119fcae2800f5ff2e8d226912c5860ae76942802ea9d23d9f6.png";